// extracted by mini-css-extract-plugin
export default {"wrapper":"Counter_wrapper__Cbs4U"};